import { CALL_API, REQUEST_GET } from '../middleware/api'
import { NONE } from '../schemas/index'

export const DOCUMENT_SESSION_REQUEST = 'DOCUMENT_SESSION_REQUEST'
export const DOCUMENT_SESSION_SUCCESS = 'DOCUMENT_SESSION_SUCCESS'
export const DOCUMENT_SESSION_FAILURE = 'DOCUMENT_SESSION_FAILURE'

function fetchDocumentSession(company, document) {
  return {
    document,
    [CALL_API]: {
      types: [
        DOCUMENT_SESSION_REQUEST,
        DOCUMENT_SESSION_SUCCESS,
        DOCUMENT_SESSION_FAILURE
      ],
      endpoint: `companies/${company.id}/content_assets/${document.id}/box_view_sessions`,
      requestType: REQUEST_GET,
      schema: NONE
    }
  }
}

function shouldFetchDocumentSession(state, document) {
  return state[document.id] == null
}

export function fetchDocumentSessionIfNeeded(company, document) {
  return (dispatch, getState) => {
    if (shouldFetchDocumentSession(getState().documentSessions, document)) {
      return dispatch(fetchDocumentSession(company, document))
    } else {
      Promise.resolve()
    }
  }
}



// WEBPACK FOOTER //
// ../src/actions/documentActions.js